import { IPerson } from "@/sg-hpr";
import { IKohderekisteriFilters, ILocationData } from "@/sg-kohderekisterit/IKohderekisteri";
import { IAuditNote, IUnsubmittedAuditNote } from "./IAuditNote";
import ICategory from "./ICategory";
import { IEvaluations, IEvaluationStatics } from "./IEvaluation";
import { IFormSchema } from "./IFormSchema";
import IFormType from "./IFormType";
import { IImage } from "./IImage";


export enum EAuditStatus {
    Draft = "luonnos",
    Finished = "valmis",
    Unknown = "tuntematon",
};

export type TAuditCounters = {
    [key in EAuditStatus]: number;
};



export const isAuditStatus = (candidate: string): candidate is EAuditStatus => {
    return [EAuditStatus.Draft, EAuditStatus.Finished].includes(candidate as EAuditStatus);
};


export interface IAuditMeta {
    title?: string;
    timestamp: Date | null;
    responsiblePerson: number;
    participants: number[];
    details?: string;
    images: IImage[];
    target?: ILocationData["id"];
    statics?: IEvaluationStatics
};

export type IAuditMetaFormData = Partial<IAuditMeta>;

interface IKnownAuditFormData {
    otsikko?: string;
    kohde?: ILocationData["id"] | null;
    tila?: EAuditStatus;
    tarkistukset: IEvaluations;
    karttasijainti?: { marker?: string };
};

export type IAuditFormData = { [key: string]: any } & Partial<IKnownAuditFormData>;

export interface IAuditOnEdit extends Pick<IAudit,
    "id" | "modifier" | "notes" | "mapLocation"
> {
    formData: IAuditFormData;
    metaData: IAuditMetaFormData;
    modifiedAt?: string;
};


export default interface IAudit {
    id: number;
    guid: string;
    title: string;

    status: EAuditStatus;
    target: ILocationData["id"] | null | undefined;
    image?: string | null;

    formType: number;
    work?: number;
    formSchema?: IFormSchema;
    formData: IAuditFormData;
    metaData: IAuditMeta;

    mapLocation?: string;

    notes: { [key: string]: IAuditNote | IUnsubmittedAuditNote };

    statics?: IEvaluationStatics;

    submitter?: number;
    submittedAt?: Date | null;

    creator: number;
    createdAt: Date | null;

    modifier: number;
    modifiedAt: Date | null | string;
    removed: boolean;

    __searchableText?: string
};



export type INewAudit = Omit<IAudit, "id" | "guid" | "status" | "modifier" | "modifiedAt" | "removed">;

export interface IAuditListSearch {
    category?: ICategory["id"];
    status?: string;
    roles?: string[];
    creator?: IPerson["id"];
};

export interface IAuditListFilters extends IKohderekisteriFilters {
    status?: EAuditStatus;
    owner?: string;
    category?: ICategory["id"];
    formType?: IFormType["id"];
    dateRange?: {
        start: Date;
        end: Date;
    };
    roles: string[];

    responsiblePerson?: IPerson["id"];

    creator?: IPerson["id"];
    freeText?: string;

    [key: string]: any;
}
